module.exports = __webpack_public_path__ + "media/images/tip_radio_button-d7c0d076616d0cdc988f3f3e8bae72e1.png";